<template>
    <div class="has-background-light">
        <div id="topbanner">
            <div id="headbanner">
                <div id="motto">Mensuel des paroisses de France
                </div>
                <div id="minimenu" class="is-hidden-mobile">
                    <router-link :to="item.route" class="has-text-dark" v-for="item in liensmenu" :key="item.route">
                        {{ item.label }}
                    </router-link>
                </div>
            </div>
            <div id="middlebanner" class="columns">
                <div class="column is-8 pt-6" align="center">
                    <img alt="logo" src="./assets/bandeau.png" width="380" height="380">
                </div>
                <div class="column is-4 px-0 is-hidden-mobile colright">
                </div>
            </div>
        </div>
        <div id="minimenumobile" class="is-hidden-tablet mt-6 mb-0 has-text-centered">
            <div class="dropdown">
                <div class="dropdown-trigger">
                    <button class="button is-medium is-warning" aria-haspopup="true" aria-controls="dropdown-menu3">
                        <span>Menu</span>
                        <span class="icon is-small">
                            <i class="fas fa-angle-down" aria-hidden="true"></i>
                        </span>
                    </button>
                </div>
                <div class="dropdown-menu" id="dropdown-menu3" role="menu">
                    <div class="dropdown-content">
                        <router-link :to="item.route" class="dropdown-item has-text-dark" v-for="item in liensmenu" :key="item.route">
                            {{ item.label }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div id="contenu">
            <router-view :key="$route.fullPath"></router-view>
        </div>
        <template>
            <div class="main-wrapper">
                <cookie-law theme="royal" buttonText="OK" message="Ce site utilise des cookies afin d'améliorer votre expérience utilisateur"></cookie-law>
            </div>
        </template>
        <div id="pied" class="has-text-centered ">
            <p class="is-size-5">Le Journal Paroissial {{ new Date().getFullYear() }}</p>
            <p>
                <router-link class="" to="/page/mentions-legales">Mentions légales</router-link>
            </p>
        </div>
    </div>
</template>
<script>
import 'aos/dist/aos.css';
import AOS from 'aos';
import CookieLaw from 'vue-cookie-law';

AOS.init()
export default {
    name: 'App',
    components: {
        CookieLaw
    },
    data: function() {
        return {
            liensmenu: [
                { route: '/', label: 'Accueil' },
                { route: '/page/achat-et-abonnement', label: 'Achat & Abonnement' },
                { route: '/page/l-association', label: 'L\'Association' },
                { route: '/page/creer-un-journal-paroissial', label: 'Créer un journal' },
                { route: '/page/partenariats', label: 'Partenariats' },
                { route: '/#contact', label: 'Contact' },
            ]
        }
    }
}
</script>
<style>
#motto {
    border-radius: 0px 0px 30px 0px;
    background: #88cef0;
    color: #204490;
    font-weight: bold;
    padding: 13px;
    text-align: left;
    float: left;
}

#minimenu {
    background-color: #0d4da1;
    padding: 10px;
    font-size: 13pt;
    text-align: right;
    float: right;
}

#minimenu a {
    color: #fff !important;
    padding-right: 15px;
}

#minimenu a:hover {
    text-decoration: underline;
}

#topbanner {
    box-shadow: 0px 10px 4px #111111;
    margin-bottom: 15px;

}

#headbanner {
    background:#0d4da1;
    height: 100px;
}

#middlebanner{
    background:#0d4da1;
    height: 300px;
    margin: 0 0 0 0;
}

#middlebanner .colright{
    background-image: url("./assets/imgbanner.jpg");
    background-size: 90%;
    background-repeat: no-repeat;
    text-align: right;
}

#pied {
    padding: 20px;
    background: #0d4da1;
    color: white;
}

#pied a {
    color: white !important;
}

h1.title, h3 {
    line-height: 1.4em !important;
    /*
    text-decoration: underline;
    text-decoration-color: royalblue;
    text-underline-offset: 6px;

    border-bottom: 6px solid royalblue;
    display: inline-block;
    padding-bottom: 5px !important;
    */
}

h1.title:after, h3:after {
    content: "";
    display: block;
    width: 75px;
    border-bottom: 6px solid royalblue;
    margin-bottom: 5px;
}


h4 {
    line-height: 1.2em !important;
    padding: 5px 0px !important;
    font-size: 24px !important;
    text-align: center;
    /*border-bottom: dashed 1px black !important;*/
    display: inline-block;
    color: #167df0;
}

h1,
h2,
h3 {
    color: #000 !important;
}

a[title="download"] {
    border-bottom: 2px dotted #779ecb !important;
}

ul {
    list-style: square inside !important;
}

ul li ul {
    padding-left: 60px;
    list-style: circle inside !important;
}

@media only screen and (max-width: 1025px) {
    #motto{
        display: none;
    }

}

@media only screen and (max-width: 515px) {

    #middlebanner .colright{
        background-image: none;
    }

    #motto{
        display: block;
    }

    #minimenu a {
        display: inline-block;
        width: 100%;
    }

    #banner {
        background-size: 80%;
    }

    #contenu {
        margin-left: 8px;
        margin-right: 8px;
    }

}
</style>